import "./Loader.scss";

import React, { memo, useMemo } from "react";

import { Spin } from "antd";
import PropTypes from "prop-types";

import { LoadingOutlined } from "@ant-design/icons";

import { useAppTheme } from "../../context/ThemeProvider";

const Loader = (props) => {
  const { COLORS } = useAppTheme();

  const {
    type,
    color = COLORS.PRIMARY,
    isFullScreen,
    style,
    loadingStyle,
  } = props;

  const renderedLoader = useMemo(() => {
    switch (type) {
      case "dots":
        return <Spin {...props} style={{ color }} />;
      case "roller":
        return (
          <div className="loading--roller">
            {Array(8)
              .fill(0)
              .map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`roller-${index}`} />
              ))}
          </div>
        );
      default:
        return <LoadingOutlined style={{ ...loadingStyle, color }} />;
    }
  }, [color, loadingStyle, props, type]);

  return (
    <div
      className="loader loader-wrapper"
      style={{
        ...style,
        ...(isFullScreen
          ? {
              position: "fixed",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }
          : {}),
      }}
    >
      {renderedLoader}
    </div>
  );
};

Loader.propTypes = {
  type: PropTypes.oneOf(["dots", "roller", "default"]),
  color: PropTypes.string,
  isFullScreen: PropTypes.bool,
  style: PropTypes.shape(),
  loadingStyle: PropTypes.shape(),
};

export default memo(Loader);
